import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/authContext";
import { logoutAuth } from "../../services/authService";

export default function Logout() {
  const navigate = useNavigate();
  const authContext = useContext(AuthContext);

  const handleLogout = () => {
    if (authContext) {
      authContext.setUser(null);
    }

    logoutAuth();
    
    navigate("/");
  };

  const handleCancel = () => {
    // Volta para a página anterior
    navigate(-1);
  };

  return (
    <main className="d-flex w-100">
      <div className="container d-flex flex-column">
        <div className="row vh-100">
          <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto d-table h-100">
            <div className="d-table-cell align-middle">

              <div className="text-center mt-4">
                <h1 className="h2">Sair do Sistema</h1>
              </div>

              <div className="card">
                <div className="card-body">
                  <div className="m-sm-3 text-center">
                    <p className="lead">
                      Tem certeza que deseja sair?
                    </p>
                    <div className="d-flex justify-content-center gap-3 mt-4">
                      <button onClick={handleLogout} className="btn btn-lg btn-danger">Sim</button>
                      <button onClick={handleCancel} className="btn btn-lg btn-secondary">Não</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}
